import { render, staticRenderFns } from "./problemSolving.vue?vue&type=template&id=6aee5680&scoped=true"
import script from "./problemSolving.vue?vue&type=script&lang=js"
export * from "./problemSolving.vue?vue&type=script&lang=js"
import style0 from "./problemSolving.vue?vue&type=style&index=0&id=6aee5680&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aee5680",
  null
  
)

export default component.exports